import React from "react";
import styled from "styled-components";
import { BiPlus, BiPrinter, BiSave, BiSearch, BiTrash } from "react-icons/bi";
import { toDecimal, XButton } from "../../core/Helper";
import { Oval } from "react-loading-icons";

export function OfficeFormToobarHeader(props) {
  const { objHead1, objHead2, objHead3, title, data, netFieldName, objAdd1 } =
    props;

  return (
    <TopBox>
      <SpanBox2> {objHead1}</SpanBox2>
      <SpanBox2 style={{ flex: "1" }}> {objHead2}</SpanBox2>
      {objHead3 ? <SpanBox2> {objHead3}</SpanBox2> : <></>}

      <NumercBigBox>
        <Span3>{title ?? ""}</Span3>{" "}
        {toDecimal(data?.[netFieldName] ?? "0.00", 2)}
        {objAdd1}
      </NumercBigBox>
    </TopBox>
  );
}

export default function OfficeFormToolbar(props) {
  const {
    addNewBill,
    searchClick,
    saveData,
    printData,
    deleteData,
    saving,
    selectedItems,
    addButtonTitle,
    searchButtonTitle,
    saveButtonTitle,
  } = props;
  return (
    <>
      <TopBox>
        <SpanBox1>
          <XButton onMouseUp={() => addNewBill()}>
            <BiPlus size={25} color="var(--icon-fore)" />{" "}
            {addButtonTitle ?? "ใบวางบิลใหม่"}
          </XButton>
          <XButton onClick={() => searchClick()}>
            <BiSearch size={25} color="var(--icon-fore)" />
            {searchButtonTitle ?? "ค้นหา"}
          </XButton>
        </SpanBox1>
        <SpanBox1>
          <XButton style={{ width: "300px" }} onMouseUp={() => saveData()}>
            {saving ? (
              <Oval height={20} />
            ) : (
              <BiSave size={25} color="var(--icon-fore)" />
            )}
            {`${saveButtonTitle ?? "บันทึกเอกสารวางบิล"}  `}
            {selectedItems && "(" + selectedItems?.length + " รายการ) "}
          </XButton>
          <XButton onMouseUp={() => printData()}>
            <BiPrinter size={25} color="var(--icon-fore)" /> พิมพ์
          </XButton>
          <XButton onMouseUp={() => deleteData && deleteData()}>
            <BiTrash size={25} color="var(--icon-fore)" /> ยกเลิก
          </XButton>
        </SpanBox1>
      </TopBox>
    </>
  );
}

const TopBox = styled.div`
  display: flex;
  padding-inline: 10px;
  padding-block: 5px;
  justify-content: space-between;
  /* background-color: red; */
`;

const SpanBox1 = styled.div`
  display: flex;
  flex-direction: row;
`;

const SpanBox2 = styled.div`
  padding-inline: 10px;
  padding-block-end: 5px;
  padding-block-start: 10px;
  margin-inline-end: 3px;
  border-radius: 15px;
  border: 1px solid var(--border-color);
`;
const Span3 = styled.div`
  flex: 1;
  font-size: 20px;
  color: var(--caption);
  display: flex;
  align-items: end;
  color: var(--caption-fore-color);
`;

export const NumercBigBox = styled.div`
  display: flex;
  flex-direction: column;
  /* min-width: 400px; */
  font-size: 50px;
  justify-content: right;
  align-items: end;
  color: var(--page-total-text-color);
  padding-inline: 20px;
`;
